module.exports = __webpack_public_path__ + "img/line.44ffe78f.svg";